import React, {Component, useEffect } from 'react';

import WelcomeScreen from './screen-welcome';

import FormValidator from './form-validator';

import CompaniesApi from '../../../lib/companies/companies-api';

import Input from '../../../components/input-with-label';
import RegistrationLayout from "./registration-layout";
import RegistrationFormContainer from './registration-form-container';
import PaginationNumber from "../../../components/pagination-number";

import Checkbox from "../../../components/checkbox";
import Dropdown from '../../../components/dropdowns/dropdown';

import CompanyTypes from '../../../components/company-types';

function Field({title, children}) {
    return (
        <div className="field gap">
            <p className="field__label">{title}</p>
            {children}
        </div>
    )
}



class CompanyDetailsScreen extends Component {

    constructor(props) {
        super(props);
        this.validator = new FormValidator([
            {
                field: 'company_name',
                method: 'isEmpty',
                validWhen: false,
                message: 'Enter your registered business'
            },
            {
                field: 'company_industry_id',
                method: 'isEmpty',
                validWhen: false,
                message: 'Enter an industry for your company'
            },
            {
                field: 'company_type',
                method: 'isEmpty',
                validWhen: false,
                message: 'Enter the type of business'
            },
            {
                field: 'company_employees',
                method: 'isEmpty',
                validWhen: false,
                message: 'Enter the number of employees'
            },
            {
                field: 'company_owner',
                method: 'isEmpty',
                validWhen: false,
                message: 'Select an option'
            },
            {
                field: 'company_owner',
                method: 'isEmpty',
                validWhen: false,
                message: 'Select an option'
            },
            {
                field: 'company_owner',
                method: this.isOwner,
                validWhen: true,
                message: 'You must be the owner/director of the business in order to create this account'
            }

        ]);

        this.state = {
            ...props,
            validation: this.validator.valid(),
            industries: [],

        }
        this.submitted = false;
    }

    isOwner = (confirmation) => ('Yes' === confirmation)

    onCheckboxTypeChange(e) {

        const option = e.option;

        if (this.props.values.company_types == option) {

            return this.props.onChange('company_type', '');
        }

        this.props.onChange('company_type', option, () => {
            this.props.onChange('company_number', '', () => {
                this.props.onChange('company_number_type', e.type)
            })
        });

    }


    onCheckboxOwnerChange({option}) {

        if (this.props.values.company_owner == option) {

            return this.props.onChange('company_owner', '');
        }
        this.props.onChange('company_owner', option);
    }

    onDropdownChange({value}) {
        this.props.onChange('company_employees', value);
    }


    onCompanyInputChange(e) {
       this.props.handleObjectChange(e);
    }

    handleChange(e) {
        this.props.onChange(e.target.name, e.target.value);
    }

    addCompanyNumberTypeValidation(validation) {
        const { values } = this.props;
        const value = values.company_number.length

        if(values.company_number_type === 'company_registration_number') {
            if(value < 8) {
                validation.company_number = { message :  'Please enter a valid Company Registration Number'};
            }
        }

        if(values.company_number_type === 'utr') {
            if(value < 10) {
                validation.company_number = { message :  'Please enter a valid UTR number'};
            }
        }

        if(values.company_number_type === 'charity_number') {
            if(value < 15) {
                validation.company_number = { message :  'Please enter a valid Charity number'};
            }
        }
    }

    onNextClick() {
        const validation = this.validator.validate({...this.props.values});
        this.setState({validation});
        this.submitted = true;
        this.addCompanyNumberTypeValidation(validation);
        if (validation.isValid) {
            this.props.onNext();
        }
    }

    onBackClick() {
        this.props.onBack();
    }

    render() {
        const validation = this.state.validation
        const {values} = this.props;
        const industrySelected = this.props.industries.find(i => i.id == values.company_industry_id)?.name;

        return (
            <RegistrationLayout
                left={<WelcomeScreen img={"/assets/onboarding-screen/card-elearning.png"} label={"Enterprising Barnsley eLearning"} title={"Learn the essentials to support your business"} description={"A range of eLearning courses to support your business and help you learn new skills to take you to the next level."}/>}
                right={<RegistrationFormContainer heading='Register your account' text="Already have an account?"
                                                  linkText='Sign In' linkHref='/login'>
                    <div className="registration-form__container gap">
                        <h2>Tell us a little bit about your business</h2>
                        <Input label="Your registered business name" type="text" name="company_name" placeholder=""
                               value={values.company_name} onChange={this.handleChange.bind(this)}
                               errors={[validation.company_name.message]}/>

                        <CompanyTypes validation={validation} values={values} handleChange={this.onCompanyInputChange.bind(this)} onCheckboxTypeChange={this.onCheckboxTypeChange.bind(this)} company_types={values.company_type}/>
                        {
                            validation.company_type.message.length > 1 &&
                            <div className='input-outer__errors'><p>{validation.company_type.message}</p></div>
                        }
                        {
                            validation.company_number?.message.length > 1 &&
                            <div className='input-outer__errors'><p>{validation.company_number.message}</p></div>
                        }
                        <div className='input-outer__errors'><p></p></div>
                        <div className='registration-form__input-row--responsive  gap'>
                            <Field title="Select your Industry">
                                <Dropdown
                                    items={this.props.industries.map((item) => {
                                        return {
                                            label: item.name,
                                            value: item.id
                                        }
                                    })}
                                    error={validation.company_industry_id.message}
                                    value={industrySelected || null}
                                    onChange={item => this.props.onChange('company_industry_id', item.value)}
                                    placeholder='Please select an industry'
                                />
                            </Field>
                            <Field title="Number of employees">
                                <Dropdown placeholder='Please select number of employees'
                                          value={{label : values.company_employees, value : values.company_employees}}
                                          error={validation.company_employees.message}
                                          items={[
                                              { label: '1-10', value: '1-10' },
                                              { label: '11-50', value: '11-50' },
                                              { label: '51-150', value: '51-150' },
                                              { label: '151-250', value: '151-250' },
                                              { label: '251+', value: '251+' }
                                            ]}
                                          onChange={this.onDropdownChange.bind(this)}/>
                            </Field>
                        </div>
                        <div className='input-outer'>
                            <div className='registration-form__checkboxes utils__row gap'>
                                <label>Are you the owner/director of the business?</label>
                                <div className='utils__row'>
                                    <Checkbox text='Yes' checked={values.company_owner == 'Yes'}
                                              onChange={this.onCheckboxOwnerChange.bind(this)}/>
                                    <Checkbox text='No' checked={values.company_owner == 'No'}
                                              onChange={this.onCheckboxOwnerChange.bind(this)}/>
                                </div>
                            </div>
                            {validation.company_owner.message.length > 0 &&
                            <div className='input-outer__errors'><p>{validation.company_owner.message}</p></div>}
                        </div>

                    </div>
                    <PaginationNumber currentPage={'2'}
                                      onNextClick={this.onNextClick.bind(this)}
                                      onBackClick={this.onBackClick.bind(this)}/>
                </RegistrationFormContainer>}/>
        );
    }
}

export default CompanyDetailsScreen;
